import addGlassLg from './assets/glass/large/add.svg';

import companiesGlassLg from './assets/glass/large/companies.svg';
import linkGlassLg from './assets/glass/large/link.svg';
import logOutGlassLg from './assets/glass/large/log-out.svg';
import notificationGlassLg from './assets/glass/large/notification.svg';
import personGlassLg from './assets/glass/large/person.svg';
import usersGlassLg from './assets/glass/large/users.svg';
import vsmeGlassLg from './assets/glass/large/vsme.svg';
import addOutlineLg from './assets/outline/large/add.svg';
import addOutlineSm from './assets/outline/small/add.svg';
import archiveOutlineSm from './assets/outline/small/archive.svg';
import arrowDownOutlineLg from './assets/outline/large/arrow-down.svg';
import arrowDownOutlineSm from './assets/outline/small/arrow-down.svg';
import arrowUpOutlineLg from './assets/outline/large/arrow-up.svg';
import companiesOutlineLg from './assets/outline/large/companies.svg';
import darkModeOutlineSm from './assets/outline/small/dark-mode.svg';
import deleteOutlineSm from './assets/outline/small/delete.svg';
import downloadOutlineSm from './assets/outline/small/download.svg';
import editOutlineLg from './assets/outline/large/edit.svg';
import editOutlineSm from './assets/outline/small/edit.svg';
import generateOutlineSm from './assets/outline/small/generate.svg';
import importedDataOutlineSm from './assets/outline/small/imported-data.svg';
import lightModeOutlineSm from './assets/outline/small/light-mode.svg';
import linkOutlineLg from './assets/outline/large/link.svg';
import linkOutlineSm from './assets/outline/small/link.svg';
import lockOutlineSm from './assets/outline/small/lock.svg';
import logOutOutlineLg from './assets/outline/large/log-out.svg';
import nextOutlineSm from './assets/outline/small/next.svg';
import noteOutlineSm from './assets/outline/small/note.svg';
import previousOutlineSm from './assets/outline/small/previous.svg';
import notificationOutlineSm from './assets/outline/small/notification.svg';
import panelCollapseOutlineLg from './assets/outline/large/panel-collapse.svg';
import personOutlineLg from './assets/outline/large/person.svg';
import restoredOutlineSm from './assets/outline/small/restored.svg';
import signOutlineSm from './assets/outline/small/sign.svg';
import tooltipOutlineSm from './assets/outline/small/tooltip.svg';
import unlockOutlineSm from './assets/outline/small/unlock.svg';
import usersOutlineLg from './assets/outline/large/users.svg';
import validateOutlineSm from './assets/outline/small/validate.svg';
import vsmeOutlineLg from './assets/outline/large/vsme.svg';
import viewOutlineLg from './assets/outline/large/view.svg';
import viewOutlineSm from './assets/outline/small/view.svg';

export type { IconAssetKey, IconSize, IconVariant } from './types';

export const addIconGlassLg = addGlassLg;

export const companiesIconGlassLg = companiesGlassLg;
export const linkIconGlassLg = linkGlassLg;
export const logOutIconGlassLg = logOutGlassLg;
export const notificationIconGlassLg = notificationGlassLg;
export const personIconGlassLg = personGlassLg;
export const usersIconGlassLg = usersGlassLg;
export const vsmeIconGlassLg = vsmeGlassLg;

/** Sidebar nav — glass large icons with light fill (orange sidebar). */
export const sidebarVsmeIcon = vsmeIconGlassLg;
export const sidebarCompaniesIcon = companiesIconGlassLg;
export const sidebarUsersIcon = usersIconGlassLg;
export const sidebarLinkIcon = linkIconGlassLg;
export const sidebarPersonIcon = personIconGlassLg;
export const sidebarLogOutIcon = logOutIconGlassLg;
export const sidebarNotificationIcon = notificationIconGlassLg;
export const addIconOutlineLg = addOutlineLg;
export const addIconSm = addOutlineSm;
export const archiveIconSm = archiveOutlineSm;
export const arrowDownIconLg = arrowDownOutlineLg;
export const arrowDownIconSm = arrowDownOutlineSm;
export const arrowUpIconLg = arrowUpOutlineLg;
export const companiesIconLg = companiesOutlineLg;
export const darkModeIconSm = darkModeOutlineSm;
export const deleteIconSm = deleteOutlineSm;
export const downloadIconSm = downloadOutlineSm;
export const editIconLg = editOutlineLg;
export const editIconSm = editOutlineSm;
export const generateIconSm = generateOutlineSm;
export const importedDataIconSm = importedDataOutlineSm;
export const lightModeIconSm = lightModeOutlineSm;
export const linkIconLg = linkOutlineLg;
export const linkIconSm = linkOutlineSm;
export const lockIconSm = lockOutlineSm;
export const logOutIconLg = logOutOutlineLg;
export const nextIconSm = nextOutlineSm;
export const noteIconSm = noteOutlineSm;
export const previousIconSm = previousOutlineSm;
export const notificationIconSm = notificationOutlineSm;
export const panelCollapseIconLg = panelCollapseOutlineLg;
export const personIconLg = personOutlineLg;
export const restoredIconSm = restoredOutlineSm;
export const signIconSm = signOutlineSm;
export const tooltipIconSm = tooltipOutlineSm;
export const unlockIconSm = unlockOutlineSm;
export const usersIconLg = usersOutlineLg;
export const validateIconSm = validateOutlineSm;
export const vsmeIconLg = vsmeOutlineLg;
export const viewIconLg = viewOutlineLg;
export const viewIconSm = viewOutlineSm;

/** @deprecated Use semantic exports (e.g. deleteIconSm). Kept for @tpct/admin-ui compatibility. */
export const deleteIcon = deleteIconSm;
/** @deprecated */
export const viewIcon = viewIconSm;
/** @deprecated */
export const downloadIcon = downloadIconSm;
/** @deprecated */
export const editIcon = editIconSm;
/** @deprecated */
export const generateIcon = generateIconSm;
/** @deprecated */
export const lockIcon = lockIconSm;
/** @deprecated */
export const unlockIcon = unlockIconSm;
/** @deprecated */
export const signIcon = signIconSm;
/** @deprecated */
export const connectIcon = linkIconSm;
/** @deprecated */
export const deconnexionIcon = logOutIconGlassLg;
/** @deprecated */
export const downArrowIcon = arrowDownIconLg;
/** @deprecated */
export const liaisonsIcon = linkIconGlassLg;
/** @deprecated */
export const mesDossiersIcon = companiesIconGlassLg;
/** @deprecated */
export const profilIcon = personIconGlassLg;
/** @deprecated */
export const utilisateursIcon = usersIconGlassLg;
/** @deprecated */
export const vsmeIcon = vsmeIconGlassLg;
/** @deprecated */
export const vsmeIconBlack = vsmeIconLg;
